// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__oZDHX","productName":"Table_productName__2v_m_"};